import { create } from 'zustand'

type PendingBalanceState = {
	pendingCashChange: number
	pendingPositionChange: number
	hasPendingCash: boolean
	hasPendingPositions: boolean
	// Add a pending balance change (e.g., when closing a position)
	addPendingChange: (cashChange: number, positionChange: number) => void
	// Clear pending changes separately
	clearPendingCash: () => void
	clearPendingPositions: () => void
}

export const usePendingBalanceStore = create<PendingBalanceState>(set => ({
	pendingCashChange: 0,
	pendingPositionChange: 0,
	hasPendingCash: false,
	hasPendingPositions: false,

	addPendingChange: (cashChange, positionChange) => {
		set({
			pendingCashChange: cashChange,
			pendingPositionChange: positionChange,
			hasPendingCash: true,
			hasPendingPositions: true,
		})

		// Auto-clear after 15 seconds (fallback if real data doesn't arrive)
		setTimeout(() => {
			set(state => ({
				pendingCashChange: state.hasPendingCash ? 0 : state.pendingCashChange,
				pendingPositionChange: state.hasPendingPositions ? 0 : state.pendingPositionChange,
				hasPendingCash: false,
				hasPendingPositions: false,
			}))
		}, 15000)
	},

	clearPendingCash: () => {
		set({
			pendingCashChange: 0,
			hasPendingCash: false,
		})
	},

	clearPendingPositions: () => {
		set({
			pendingPositionChange: 0,
			hasPendingPositions: false,
		})
	},
}))
